var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useCallback } from 'react';
import { cx, css as emotionCss } from 'emotion';
import { MenuItem, MenuItemDisabled } from './Flyout.styled';
import { menuItemFocused } from '../styles/legacy';
import { getAutomation, getDebug, getStyleNames, useCitrusDebug } from '@citrus/runtime';
import { isNotNilOrEmpty, downKeyPressed, upKeyPressed, isNilOrEmpty } from '@pcty/utils';
import { useFocusRing, useFocusManager } from '@react-aria/focus';
var VERSION = '5.5.1';
/** DISPLAY NAME: &lt;Flyout.MenuItem&gt; */
var FlyoutMenuItem = function (_a) {
    var _b;
    var automationId = _a.automationId, children = _a.children, className = _a.className, css = _a.css, disabled = _a.disabled, _c = _a.hidden, hidden = _c === void 0 ? false : _c, id = _a.id, onClick = _a.onClick, _d = _a.visible, visible = _d === void 0 ? true : _d, _e = _a.__TYPE, __TYPE = _e === void 0 ? 'FlyoutMenuItem' : _e, other = __rest(_a, ["automationId", "children", "className", "css", "disabled", "hidden", "id", "onClick", "visible", "__TYPE"]);
    var debug = useCitrusDebug();
    var _f = useFocusRing(), isFocusVisible = _f.isFocusVisible, focusProps = _f.focusProps;
    var focusManager = useFocusManager();
    var classes = cx((_b = {},
        _b[emotionCss(css)] = isNotNilOrEmpty(css),
        _b[emotionCss(menuItemFocused)] = isFocusVisible,
        _b), className || '');
    // eslint-disable-next-line react-hooks/rules-of-hooks, react-hooks/exhaustive-deps
    var onClickHandler = useCallback(disabled ? function (e) { return e.stopPropagation(); } : function (e) { return onClick({ id: id, e: e }); }, [disabled, id, onClick]);
    var Item = disabled ? MenuItemDisabled : MenuItem;
    var keyDownHandler = function (event) {
        if (downKeyPressed(event)) {
            event.preventDefault();
            focusManager.focusNext({ wrap: true, tabbable: false });
        }
        if (upKeyPressed(event)) {
            event.preventDefault();
            focusManager.focusPrevious({ wrap: true, tabbable: false });
        }
    };
    if (hidden || !visible || isNilOrEmpty(children))
        return null;
    return (React.createElement(Item, __assign({ "aria-disabled": disabled, className: classes, disabled: disabled, id: id, onClick: onClickHandler, onKeyDown: keyDownHandler, role: "menuitem", styleNames: getStyleNames({ menuItemFocused: isFocusVisible }), tabIndex: isFocusVisible ? 0 : -1 }, focusProps, other, getAutomation(automationId), getDebug(debug, __TYPE, VERSION)), children));
};
FlyoutMenuItem.defaultProps = {
    __TYPE: 'FlyoutMenuItem',
};
export default FlyoutMenuItem;
